import React from 'react';
import MainLayoutIgniter from "../common/mainLayout";
import {Heading2, Heading3, Text4} from "../../../libs/uiKit/globalStyledComponents";
import {
    StyledContractHeader, StyledContractRegistrationForm,
    StyledContractWrapper,
    StyledEventsButtons,
} from "../contract/ui/styles";
import DropdownMenu from "../../../libs/uiKit/dropdownMenu";
import Button from "../../../libs/uiKit/button";
import {MoreIcon} from "../../../icons/ui/More";
import {DownloadIcon} from "../../../icons/ui/Download";
import FlyButtons from "../../../libs/uiKit/flyButtons";
import {FieldsBuilder} from "../../../libs/uiKit/fieldsBuilder";
import {IForm, TypeFormHook} from "../../../libs/uiKit/fieldsBuilder/types";
import dayjs from "dayjs";
import {useForm} from "react-hook-form";
import {ContractForm} from "../contract";
import {formatDateToStringRu} from "../../../libs/utils/gormatDateToUsa";
import {getClearSelectValue} from "../../../libs/utils/getSelectdefaultValue";
import {useMutation} from "@apollo/client";
import {
    FlatFormForm,
    FlatFormInput,
    SaveAgreementMutation,
    SaveAgreementMutationVariables,
    SaveFlatMutation,
    SaveFlatMutationVariables
} from "../../../libs/api/graphqlTypes";
import {SAVE_AGREEMENT_DRAFT, SAVE_FLAT} from "../../../libs/api/commands";
import {
    StyledBigPremiumHeader, StyledCrossedPremiumHeader,
    StyledHeaderWrapper,
    StyledInputWithApplyButton,
    StyledSmallApplyButton
} from "./styles";
import useNotification from "../../widgets/notifier/ui/hooks/useNitification";
import {
    StyledBankCard, StyledBankTable, StyledBankTableColumns, StyledBorrowerNeedOsm,
    StyledPrecalculationForm,
    StyledPrecalculationFormCard,
    StyledPrecalculationFormCardWrapper,
    StyledPrecalculationFormWrapper
} from "../precalculation/ui/styles";
import {ArrowIcon} from "../../../icons/ui/Arrow";
import {useNavigate} from "react-router-dom";
import {
    StyledGrayLabel,
    StyledPremiumBlock,
    StyledSmallPremiumHeader
} from "../invoice/ui/styles";
import {stringToMoney} from "../../../libs/uiKit/utils";
import {useGlobalContext} from "../../../apps/main/ui/GlobalContext";
import Input from "../../../libs/uiKit/input";
import NumberInput from "../../../libs/uiKit/floatInput/NumberInput";
import {CloseIcon} from "../../../libs/uiKit/icons/Close";
import {QuestionIcon} from "../../../icons/ui/Question";

export type FlatForm = {
    flatStructuralElements?: number;
    flatFinishing?: number;
    flatMovableProperty?: number;
    flatCivilResponsibility?: number;
    flatLease?: boolean;
    flatRenovation?: boolean;
    flatAlarmSecurity?: boolean;
    flatAlarmFire?: boolean;
    flatLeakageProtection?: boolean;
    flatSellerDiscountDueKv?: number;
    flatPromoCode?: string;
    flatYearBuild?: number;
    promocode?: string;
}

export const getFlatPrecalcForm = (formHook: TypeFormHook, isDisabled?: boolean, onChange?: () => void): IForm => ({
    formHook,
    fields: [
        {
            field: {
                fieldType: 'checkbox',
                fieldName: 'flatLease',
                isRequired: false,
                width: '27rem',
                label: "Квартира сдается в аренду",
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'checkbox',
                fieldName: 'flatRenovation',
                isRequired: false,
                grid: 6,
                label: "Проводятся ремонтные работы",
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'element',
                fieldName: 'AlarmCaption',
                element: <StyledGrayLabel style={{marginBottom: '-15px'}}>В квартире есть сигнализация:</StyledGrayLabel>,
            }
        },
        {
            field: {
                fieldType: 'checkbox',
                fieldName: 'flatAlarmSecurity',
                isRequired: false,
                width: '17rem',
                label: "Охранная",
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'checkbox',
                fieldName: 'flatAlarmFire',
                isRequired: false,
                width: '17rem',
                label: "Пожарная",
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'checkbox',
                fieldName: 'flatLeakageProtection',
                isRequired: false,
                grid: 4,
                label: "От протечек воды",
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'number',
                fieldName: 'flatYearBuild',
                isRequired: true,
                placeholder: 'Год постройки дома',
                grid: 6,
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'element',
                fieldName: 'WhatisInsured',
                element: <Heading3 style={{marginBottom: '-10px'}}>{isDisabled ? 'Что застраховано' : 'Что нужно застраховать?'}</Heading3>,
            }
        },
        {
            field: {
                fieldType: 'range',
                fieldName: 'flatStructuralElements',
                placeholder: 'Конструктивные элементы, ₽',
                grid: 12,
                min: 100000,
                max: 10000000,
                step: 100000,
                moneyFormat: true,
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'range',
                fieldName: 'flatFinishing',
                placeholder: 'Внутренняя отделка, ₽',
                grid: 12,
                min: 100000,
                max: 5000000,
                step: 100000,
                moneyFormat: true,
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'range',
                fieldName: 'flatMovableProperty',
                placeholder: 'Движимое имущeство, ₽',
                grid: 12,
                min: 100000,
                max: 2500000,
                step: 100000,
                moneyFormat: true,
                isDisabled,
                onChange,
            },
        },
        {
            field: {
                fieldType: 'range',
                fieldName: 'flatCivilResponsibility',
                placeholder: 'Гражданская ответственность, ₽',
                grid: 12,
                min: 100000,
                max: 1000000,
                step: 100000,
                moneyFormat: true,
                isDisabled,
                onChange,
            },
        },
    ],
})

const FlatPage = () => {

    const formHook = useForm<FlatForm>({ mode: 'onBlur' });

    const { setNotification } = useNotification();

    const navigate = useNavigate();

    const {
        routes: { createAgreementStep },
        user: { isStaffMember },
    } = useGlobalContext();

    const [calcResult, setCalcResult] = React.useState<any>(null);
    const [flatFormInput, setFlatFormInput] = React.useState<FlatFormInput>({});
    const [formChanged, setFormChanged] = React.useState<boolean>(true);

    const [statePromocode, setStatePromocode] = React.useState<string>('');
    const [stateDiscount, setStateDiscount] = React.useState<number|undefined>(undefined);
    const [stateAppliedPromocode, setStateAppliedPromocode] = React.useState<string>('');
    const [stateAppliedDiscount, setStateAppliedDiscount] = React.useState<number|undefined>(undefined);
    const [isPromocodeInvalid, setIsPromocodeInvalid] = React.useState<boolean>(false);
    const [lastWrongPromocode, setLastWrongPromocode] = React.useState<string>('');

    const [saveAgreement, { loading: loadingSaveAgreement }] = useMutation<SaveAgreementMutation, SaveAgreementMutationVariables>(SAVE_AGREEMENT_DRAFT);
    const [saveFlat, { loading: loadingSaveFlat }] = useMutation<SaveFlatMutation, SaveFlatMutationVariables>(SAVE_FLAT);

    const recalc = (calcForm: FlatFormInput) => {
        setIsPromocodeInvalid(false)
        saveFlat({
            variables: {
                id: 0,
                calcForm,
            }
        }).then(res => {
            setFlatFormInput(calcForm);
            setCalcResult(res.data?.saveFlat);
            setStateAppliedPromocode(calcForm.promo_code || '');
            setStateAppliedDiscount(calcForm.seller_discount_due_kv || undefined);
            setFormChanged(false);
        }).catch(error => {
            if(error.message === 'promocode'){
                setIsPromocodeInvalid(true)
                setLastWrongPromocode(calcForm.promo_code || '');
            } else {
                setNotification({type: 'error', text: error});
            }
        });
    }

    const onSubmit = (data: FlatForm) => {
        if (!data.flatStructuralElements && !data.flatFinishing && !data.flatMovableProperty && !data.flatCivilResponsibility) {
            formHook.setError('flatStructuralElements', { type: 'manual', message: 'Укажите хотя бы одну сумму' });
            return;
        }
        const calcForm: FlatFormInput = {
            structural_elements: data.flatStructuralElements ? parseInt(String(data.flatStructuralElements), 10) : undefined,
            finishing: data.flatFinishing ? parseInt(String(data.flatFinishing), 10) : undefined,
            movable_property: data.flatMovableProperty ? parseInt(String(data.flatMovableProperty), 10) : undefined,
            civil_responsibility: data.flatCivilResponsibility ? parseInt(String(data.flatCivilResponsibility), 10) : undefined,
            lease: data.flatLease,
            renovation: data.flatRenovation,
            alarm_security: data.flatAlarmSecurity,
            alarm_fire: data.flatAlarmFire,
            leakage_protection: data.flatLeakageProtection,
            build_year: data.flatYearBuild,
            promo_code: statePromocode,
            seller_discount_due_kv: stateDiscount,
        };
        recalc(calcForm);
    }

    const onFormSubmit = formHook.handleSubmit(onSubmit);

    flatFormInput.precalcResult = calcResult;

    const createAgreement = () => {
        saveAgreement({
            variables: {
                calcForm: {
                    flat: flatFormInput
                },
                product: 2
            }
        }).then(res => {
            const id = res.data?.saveAgreement;
            if (id) {
                navigate(createAgreementStep(String(id), 'flat'));
            }
        }).catch(error => {
            setNotification({ type: 'error', text: error });
        });
    }

    const formPart1 = getFlatPrecalcForm(formHook, false, () => {
        setFormChanged(true);
    });

    return (
        <MainLayoutIgniter>
            <StyledPrecalculationFormWrapper>
                <Button onClick={() => navigate(-1)} appearance='text' iconBefore={<ArrowIcon direction='left' />}>
                    Назад
                </Button>
                <form onSubmit={onFormSubmit}>
                    <StyledPrecalculationFormCardWrapper style={{gridTemplateColumns: "2fr 1fr"}}>
                        <StyledPrecalculationFormCard>
                            <Heading2>Расчёт</Heading2>
                                <StyledPrecalculationForm>
                                    <Heading3>Общая информация о квартире</Heading3>
                                    <br/><br/>
                                    <FieldsBuilder {...formPart1} />
                                </StyledPrecalculationForm>
                                <Button isLoading={loadingSaveFlat} type='submit' appearance='filled' isDisabled={!formChanged}>
                                    Рассчитать
                                </Button>
                        </StyledPrecalculationFormCard>
                        {calcResult &&
                            <StyledPrecalculationFormCard>
                                <Heading2>&nbsp;</Heading2>
                                <StyledBankCard>
                                    <StyledBankTable>
                                        <StyledBankTableColumns>
                                            <Text4/>
                                            <Text4/>
                                            <Text4 className="opa05 right">Страховая&nbsp;сумма</Text4>
                                            {/*<Text4 className="right opa05">Премия</Text4>*/}
                                            {(calcResult?.details || []).map((item: any, index: number) =>
                                                (
                                                    <React.Fragment key={`calc-item-${index}`}>
                                                        <Text4 className="mt15">{item?.name}</Text4>
                                                        <Text4/>
                                                        <Text4 className="mt15 right">{item?.limit_sum ? stringToMoney(item?.limit_sum, 0) : ""}</Text4>
                                                        {/*<Text4 className="right mt15">1 000.00</Text4>*/}
                                                    </React.Fragment>
                                                ))}
                                        </StyledBankTableColumns>
                                    </StyledBankTable>
                                    <StyledInputWithApplyButton isGreen={statePromocode === stateAppliedPromocode}>
                                        <Input
                                            placeholder='Промокод'
                                            name='promocode'
                                            onChange={e => setStatePromocode(e.target.value)}
                                            isLoading={loadingSaveFlat}
                                            value={statePromocode}
                                            isInvalid={isPromocodeInvalid}
                                            errorMessage={isPromocodeInvalid ? 'Неверный промокод' : undefined}
                                            iconAfter={statePromocode && statePromocode !== lastWrongPromocode ? (statePromocode !== stateAppliedPromocode
                                                ? <StyledSmallApplyButton>
                                                    <Button appearance='transparent' type='submit'>Применить</Button>
                                                  </StyledSmallApplyButton>
                                                : <Button appearance='icon' type='submit' onClick={(): void => {
                                                    setStatePromocode('')
                                                    recalc({...flatFormInput, promo_code: ''});
                                                }
                                                } icon={<CloseIcon />} />) : undefined}
                                        />
                                    </StyledInputWithApplyButton>
                                    {!isStaffMember && <StyledInputWithApplyButton isGreen={stateDiscount === stateAppliedDiscount}>
                                        <NumberInput
                                            placeholder='Скидка за счет КВ'
                                            name='discount'
                                            onChange={e => setStateDiscount(parseInt(e.target.value, 10))}
                                            isLoading={loadingSaveFlat}
                                            value={stateDiscount || ''}
                                            iconAfter={stateDiscount ? (stateDiscount !== stateAppliedDiscount
                                                ? <StyledSmallApplyButton>
                                                    <Button appearance='transparent' type='submit'>Применить</Button>
                                                </StyledSmallApplyButton>
                                                : <Button appearance='icon' type='submit' onClick={(): void => {
                                                    setStateDiscount(undefined)
                                                    recalc({...flatFormInput, seller_discount_due_kv: undefined});
                                                }
                                                } icon={<CloseIcon />} />) : undefined}
                                        />
                                    </StyledInputWithApplyButton>
                                    }

                                    <StyledPremiumBlock>
                                        <StyledGrayLabel style={{textAlign: 'right'}}>Страховая премия</StyledGrayLabel>

                                        <StyledBigPremiumHeader style={{textAlign: 'right'}}>
                                            {calcResult?.old_premium_sum && <>
                                                <StyledCrossedPremiumHeader>{stringToMoney(calcResult?.old_premium_sum)} RUB</StyledCrossedPremiumHeader> &nbsp;
                                            </>}

                                            {stringToMoney(calcResult?.premium_sum)} ₽
                                        </StyledBigPremiumHeader>
                                    </StyledPremiumBlock>
                                    <Button type='submit' appearance='filled' isLoading={loadingSaveAgreement} onClick={createAgreement} isDisabled={formChanged}>
                                        Оформить
                                    </Button>
                                </StyledBankCard>
                            </StyledPrecalculationFormCard>
                        }
                    </StyledPrecalculationFormCardWrapper>
                </form>
            </StyledPrecalculationFormWrapper>
        </MainLayoutIgniter>
    );
}

export default FlatPage;